module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-lightning-fill-1136895e.svg";